var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"1300","fullscreen":_vm.$vuetify.breakpoint.mobile,"scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('search-detail',{attrs:{"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }